import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  Tooltip,
  DialogContent,
  Dialog,
  DialogActions,
  TextField,
  Autocomplete,
} from "@mui/material";
import { toast } from "react-toastify";
import { Close } from "@mui/icons-material";
import Axios from "../axios";
import { Helmet } from "react-helmet";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { CSVLink } from "react-csv";
import { useLocation } from "react-router-dom";
import { useAuth } from "../auth/authContext";
const UserRoleListing = () => {
  const location = useLocation();
  const { navData } = useAuth();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [allTrip, setAllTrip] = useState();
  const [allRole, setAllRoles] = useState([]);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const [opendel, setOpenDel] = useState(false);
  const [type, setType] = useState("");
  const [role, setRole] = useState();
  const [id, setID] = useState();
  const [write, setWrite] = useState(false);
  const { passedValue } = location?.state || {};
  //data for the CSV file
  const [downloadData, setDownloadData] = useState([]);
  //header for the CSv file
  const headers = [
    { label: "Trip Name", key: "tripName" },
    { label: "User Name", key: "userName" },
    { label: "Created Date", key: "createdAt" },
    { label: "Feature Status", key: "featureuserStatus" },
  ];

  useEffect(() => {
    fetchAllUserAdmin(0, "", ""); // Default behavior
    fetchAllRoles(0, "", "");
  }, []);
  useEffect(() => {
    const currentPath = location.pathname;
    const matchingNavItem = navData.find((item) => item.link === currentPath);
    if (matchingNavItem) {
      setWrite(matchingNavItem.write);
    } else {
      setWrite(false);
    }
  }, [location.pathname, navData]);
  const fetchAllUserAdmin = (page, search) => {
    Axios.post(process.env.REACT_APP_BACKEND + "get-admins", {
      page,
      limit: 10,
      searchChar: search,
    })
      .then((resp) => {
        setAllTrip(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const fetchAllRoles = (page, search) => {
    let data = {
      page: page,
      searchChar: search,
    };

    Axios.post(process.env.REACT_APP_BACKEND + "get-roles", data)
      .then((resp) => {
        // Set allRoles to the entire data array, not just the 'role' field
        setAllRoles(resp?.data?.data || []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            "An error occurred while fetching roles"
        );
      });
  };

  const handleDelete = () => {
    let data = {
      id: id,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "delete-admins", data)

      .then((resp) => {
        fetchAllUserAdmin(page, search);
        toast.success(resp && resp.data && resp.data.message);
        handleClose();
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  //-------------option for the mui table----------------------------

  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    viewColumns: false,
    rowsPerPageOptions: [],
    serverSide: true,
    download: false,
    count: count,
    page,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        fetchAllUserAdmin(tableState.page, search);
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      fetchAllUserAdmin(page, searchText);
      setSearch(searchText);
    },
    customToolbar: () => (
      <>
        <Tooltip title="Download">
          <IconButton>
            <CSVLink
              data={downloadData}
              headers={headers}
              filename={"featuretrip.csv"}
            >
              <DownloadIcon />
            </CSVLink>
          </IconButton>
        </Tooltip>
      </>
    ),
  };
  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "name") {
      setName(value);
    } else if (name === "email") {
      setEmail(value);
    } else if (name === "role") {
      setRole(value);
    }
  };

  const columns = [
    {
      name: "name",
      label: "User Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "role",
      label: "Role",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const roles = allTrip[dataIndex]?.roles?.role;
          return <>{roles}</>;
        },
      },
    },
    write && {
      name: "options",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Tooltip title="Edit">
                <IconButton
                  aria-label="Edit "
                  onClick={() => handleOpen(allTrip[dataIndex], "edit")}
                >
                  <EditOutlinedIcon className="icon-size" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton
                  aria-label="Delete "
                  onClick={() => handleOpen(allTrip[dataIndex]._id, "delete")}
                >
                  <DeleteOutlineOutlinedIcon className="red-color fs-16 icon-size" />
                </IconButton>
              </Tooltip>
            </>
          );
        },
      },
    },
  ].filter(Boolean);
  // Function for dialog open close
  const handleOpen = (userid, type) => {
    if (type === "edit") {
      setOpen(true);
      setID(userid?._id);
      setName(userid?.name);
      setEmail(userid?.email);
      setRole(userid?.roles);
      setType("edit");
    } else if (type === "delete") {
      setID(userid);
      setOpenDel(true);
    } else {
      setOpen(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setRole("");
    setOpenDel(false);
    setEmail("");
    setName("");
  };
  function validateEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }
  const handleSubmit = () => {
    let api;
    let data;
    if (name === "") {
      toast.error("Name is required ");
      return;
    }
    if (!validateEmail(email)) {
      toast.error("Enter Correct Email ");
      return;
    }
    if (role === "") {
      toast.error("Select Role ");
      return;
    }
    if (type === "edit") {
      api = "update-admins";
      data = {
        id: id,
        email: email,
        name: name,
        roles: role?._id,
      };
    } else {
      api = "create-admins";
      data = {
        roles: role?._id,
        name: name,
        email: email,
      };
    }

    Axios.post(process.env.REACT_APP_BACKEND + api, data)
      .then((resp) => {
        fetchAllUserAdmin(page, search);
        toast.success(resp && resp.data && resp.data.message);
        handleClose();
      })
      .catch((err) => {
        toast.error(err?.message);
      });
  };
  return (
    <>
      <Helmet>
        <title>Sevenly-UserRole</title>
        <meta name="Feature Trip" content="Feature Trip for Home Page" />
      </Helmet>

      <div className="d-flex justify-content-end mb-2">
        {write ? (
          <Button className="w7 sevenly-btn text-white" onClick={handleOpen}>
            Add
          </Button>
        ) : (
          <></>
        )}
      </div>
      <MUIDataTable
        title={"User Role List"}
        data={allTrip}
        columns={columns}
        options={options}
      />

      {/* ------------------------------Create Trip Section ---------------------------------------- */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={open}
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3> User Details</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <TextField
            label="Name"
            variant="outlined"
            fullWidth
            className="my-2"
            placeholder="Enter Name"
            name="name"
            onChange={handleChange}
            value={name}
          />
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            className="my-2"
            type="email"
            placeholder="abc@sevenly.com"
            onChange={handleChange}
            name="email"
            value={email}
          />
          <Autocomplete
            className="my-2"
            id="tags-outlined"
            options={allRole}
            value={role}
            getOptionLabel={(option) => (option ? option.role : "")}
            onChange={(event, newValue) => {
              setRole(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                className="my-2"
                label="Select Roles"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
          <Button
            className="submit-button"
            variant="contained"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={opendel}
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>Delete User Role</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <p className="fs-14">
            {"Are you sure you want to Delete the user Role ?"}
          </p>
        </DialogContent>
        <DialogActions>
          <Button className="cancel-button" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className="submit-button"
            variant="contained"
            onClick={handleDelete}
          >
            {"Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default UserRoleListing;
